// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 995) return "shell/modern_shell.css?cacheBreaker=7e4a39705f285fc91135";
	if (chunkId === 179) return "modules/modern_prismjs-179.css?cacheBreaker=b12127ee06be5a35313b";
	if (chunkId === 632) return "modules/modern_externalAuth-632.css?cacheBreaker=4972dfa7f5dc949ca4a0";
	if (chunkId === 76) return "designer/modern_designer.css?cacheBreaker=48d5068b57be3db801bb";
	if (chunkId === 517) return "modules/modern_calendar-517.css?cacheBreaker=c512f907762027889817";
	// return url for filenames based on template
	return undefined;
};